module.exports = __webpack_public_path__ + "img/ab2c9f7.jpg";